<!-- Le template -->
<template>
  <v-container :key="componentKey">
    <v-row class="mt-1">
      <v-col cols="12" class="d-flex justify-start align-center">
        <!--Choix du client-->
        <h3 class="mr-3 my-0">SIG prévisionnel de :</h3>
        <v-autocomplete
          class="mr-3 my-0"
          label="Rechercher Sélectionner un client"
          :items="clients"
          clearable
          deletable-chips
          item-value="id"
          return-object
          v-model="selectedClient"
          dense
          :rules="[rules.required]"
        ></v-autocomplete>

        <!--Annee-->
        <v-select
          v-if="!diagnostic_years_loading"
          menu-props="auto"
          class="mr-4 my-0"
          dense
          multiple
          small-chips
          deletable-chips
          @change="get_crs()"
          label="Année de prévisionnel"
          v-model="diagnostic_years"
          :items="possibles_diagnostic_years"
          :rules="[rules.required_select]"
        ></v-select>

        <!--Switch K€ -->
        <v-switch
          class="mr-3 my-0"
          dense
          label="K€"
          v-model="kilo_euro"
        ></v-switch>
        <!--Switch % Visibility -->
        <v-switch
          class="mr-3 my-0"
          dense
          label="K€"
          v-model="show_pourcent"
        >
        <template v-slot:label>
          <v-icon v-if="show_pourcent">mdi-eye-outline</v-icon><v-icon v-else>mdi-eye-off-outline</v-icon>%
        </template>

        </v-switch>
        <!--Switch base % -->
        <v-switch
          v-model="pourcent_PE"          
          class="mr-3 my-0"
          dense
          label="%PE"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row v-if="selectedClient && diagnostic_years.length != 0">
      <v-col>
        
             <v-row>
              <v-col class="d-flex justify-space-between pb-5 align-center">
                <h6 class="mb-0"></h6>
                <div class="d-flex justify-space-between">
                  <v-btn
                    @click="exportImage('sigimagetable')"
                    color="grey darken-3"
                    class="mr-1"
                  >
                    <v-icon dark left>mdi-file-image</v-icon>image
                  </v-btn>

                  <export-excel
                    v-if="!sig_loading"
                    :data="sigs"
                    name="sig.xls"
                    :fields="set_excelHeaders()"
                  >
                    <v-btn color="grey darken-3 ">
                      <v-icon dark left>mdi-file-export-outline</v-icon>
                      Excel
                    </v-btn>
                  </export-excel>



                </div>
              </v-col>
            </v-row>

            <v-progress-linear
              v-if="GlobalLoading"
              color="light-blue darken-1"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>

            <!-- SIG Visible Table -->
            <v-simple-table
              v-if="!sig_loading && !GlobalLoading"
              fixed-header
              dark
              dense
              :key="sigDatatableKey"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" rowspan="2" style="padding: 5px">
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-checkbox
                            @click="toggleAllRowVisibility(selectall_sig, sigs)"
                            v-model="selectall_sig"
                            true-value="1"
                            false-value="0"
                            v-on="on"
                            dense
                            hide-details
                            color="grey lighten-5"
                          ></v-checkbox>
                        </template>
                        <span>Tout Masquer (pour l'exportation en image)</span>
                      </v-tooltip>
                    </th>
                    <th class="text-left border-right" rowspan="2">Intitulé</th>
                    <th
                      v-for="annee in previs_years_ordered"
                      :key="annee.entete1"
                      class="text-right border-right border-left"
                      
                      :colspan="show_pourcent ? 2 : 1"
                    ><!--colspan="2"-->
                      {{ annee }}
                    </th>
                  </tr>

                  <tr>
                    <template v-for="annee in previs_years_ordered">
                      <th
                        :key="annee.entete2"                        
                        :class="show_pourcent ? 'text-right euro_header':'text-right euro_header border-right' "
                      >
                        <span v-if="kilo_euro">K</span>€
                      </th>
                      <th v-if="show_pourcent"
                        :key="annee.entete2"
                        class="text-right pourcent_header border-right"
                      >
                        %
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(sig, sigindex) in sigs"
                    :key="sigindex"
                    :class="`rang` + sig.rang"
                  >
                    <td class="checkboxTD">
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-checkbox
                            v-model="sigs[sigindex].show"
                            @click="
                              toggleRowVisibility(
                                sigs[sigindex].show,
                                sigs,
                                sigindex
                              )
                            "
                            v-on="on"
                            :input-value="sigs[sigindex].show"
                            true-value="1"
                            false-value="0"
                            dense
                            hide-details
                            color="grey lighten-5"
                          ></v-checkbox>
                        </template>
                        <span
                          >Masquer cette ligne pour l'exportation en image</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ sig.intitule }}</td>
                    <template v-for="annee in previs_years_ordered">
                      <td :key="annee.index" :class="show_pourcent ? 'text-right border-left' : 'text-right border-left border-right'" >
                        {{ format(sig[annee], sig) }}
                      </td>
                      <td v-if="show_pourcent" :key="annee.index" class="text-right pourcent border-right">
                        {{ pourcent_sig(sig, annee) }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>


         <!-- SIG Export image Table    -->
            <div style="position: absolute; z-index: -1;top:-10000px">
              <v-simple-table
                v-if="!sig_loading && !GlobalLoading"
                dense
                id="sigimagetable"
                class="pb-3 imgtable"
                light
                :key="exportSigDatatableKey"
              >
                <template v-slot:default>
                  <thead>
                    <tr style="background-color: #0c6682">
                      <th
                        class="text-left"
                        rowspan="2"
                        style="color: #ffffff !important"
                      >
                        Intitulé
                      </th>
                      <th
                        v-for="annee in previs_years_ordered"
                        :key="annee.entete1"
                        class="text-right border-left"
                        :colspan="show_pourcent ? 2 : 1"
                        style="color: #ffffff !important"
                      >
                        {{ annee }}
                      </th>
                    </tr>

                    <tr style="background-color: #0c6682">
                      <template v-for="annee in previs_years_ordered">
                        <th
                          :key="annee.entete2"
                          class="text-right euro_header border-left"
                          style="color: #ffffff !important"
                        >
                          <span v-if="kilo_euro">K</span>€
                        </th>
                        <th v-if="show_pourcent"
                          :key="annee.entete2"
                          class="text-right pourcent_header"
                          style="color: #ffffff !important"
                        >
                          %
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(sigitem, sigitemindex) in sigs">
                      <tr
                        v-if="sigs[sigitemindex].show == '1'"
                        :key="sigitemindex"
                        :class="`rang` + sigitem.rang"
                      >
                        <td>{{ sigitem.intitule }}</td>
                        <template v-for="annee in previs_years_ordered">
                          <td :key="annee.index" class="text-right border-left">
                            {{ format(sigitem[annee], sigitem) }}
                          </td>
                          <td v-if="show_pourcent" :key="annee.index" class="text-right pourcent">
                            {{ pourcent_sig(sigitem, annee) }}
                          </td>
                        </template>
                      </tr>

                      <tr
                        style="background-color: #ffffff !important"
                        v-if="
                          sigitem.rang == 3 && sigs[sigitemindex].show == '1'
                        "
                        :key="sigitemindex + 'ter1'"
                      >
                        <td style="border-bottom: 0px !important">&nbsp;</td>
                        <template v-for="annee in previs_years_ordered">
                          <td
                            :key="annee.index"
                            class="text-right value border-left"
                            style="border-bottom: 0px !important"
                          ></td>
                          <td
                            v-if="show_pourcent"
                            :key="annee.index"
                            class="text-right value"
                            style="border-bottom: 0px !important"
                          ></td>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </div>      
        
      </v-col>
    </v-row>

  </v-container>
</template>

<style>
.imgtable td,
.imgtable th {
  height: auto !important;
  line-height: 1.3 !important;
}
.imgtable .rang4 td {
  padding: 8px !important;
}

/* 
alternance gris / blanc pour l'export en image des tableaux
tout en blanc cf recette 14/12

.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.03);
}
*/

.theme--dark.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.5);
}

/* .rang0 {font-weight: 200;} */

.rang0 ul {
  margin-bottom: 0px !important;
  font-size: 0.9em !important;
}

.rang0 .value {
  font-size: 0.9em !important;
}

.pourcent {
  font-style: italic;
}

.rang2 {
  background-color: #a6a6a6 !important;
}

.rang3 {
  background-color: #1ab7ea !important;
}

.rang4 {
  background-color: #0c6682 !important;
}

.rang4 td {
  padding: 20px !important;
}

.checkboxTD {
  width: 10px !important;
  padding: 5px 0 5px 5px !important;
}
.imgtable .rang4,
.imgtable .rang3 {
  color: #ffffff;
  font-weight: 400;
}
.imgtable .rang2 {
  color: #000000;
  font-weight: 400;
}
.br_header {
  width: 220px;
}
.euro_header {
  width: 100px;
}
.pourcent_header {
  width: 75px;
}

.border-left {
  border-left: 1px solid gray;
}
</style>

<script>
import { EventBus } from "../../../EventBus";

import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";

// Le script
export default {
  data() {
    return {
      rules: {
        required: (v) => !!v || "Ce champ est requis",
        required_select: (v) => v.length > 0 || "Ce champ est requis",
      },

      sigDatatableKey: 0,
      exportSigDatatableKey: 0,

      componentKey: 0,

      GlobalLoading: true,

      Loading: true,
      cr_loading: true,     
      sig_loading: true,   

      diagnostic_years_loading: true,
      ClientsLoading: true,
      selectedClient: null,
      clients: [],
      possibles_diagnostic_years: [],
      diagnostic_years: [],
      kilo_euro: false,
      pourcent_PE: false,
      show_pourcent:true,

      selectall_sig: "1",


      crs: [], // compte de résultat par année
      // solde intermédiaire de gestion
      sigs: [
        {
          // Chiffre d'affaires	"Ventes" + "Prestations de services" = 	2(cr)+3(cr)
          intitule: "Chiffre d'affaires",
          rang: 2,
          ajouter: [{ base: "crs", lignes: [2,3] },],
          soustraire: [],
        },

        {
          // "Production stockée" + "Production immobilisée"	= 5(cr)+6(cr)
          intitule: "Production stockée / immobilisée",
          rang: 1,
          ajouter: [{ base: "crs", lignes: [5,6] },],
          soustraire: [],
        },
        {
          //"Achats" + "Variation de stocks" = 16(cr)+22(cr)
          intitule: "Achat consommé", //Achat consommé dont 604 achat études et prestation de service" label modifié cf mail du 12/04/2023,
          rang: 1,
          ajouter: [{ base: "crs", lignes: [16,22] },],
          soustraire: [],
        },
        {
          //Marge brute	= "Chiffre d'affaires" + "Production stockée / immobilisée" - "Achat consommé"	 = 2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)
          intitule: "Marge brute",
          rang: 2,
          ajouter: [{ base: "crs", lignes: [2,3,5,6]  },],
          soustraire: [{ base: "crs", lignes: [16,22]  }],
        },
        {
          //Autres achats et charges externes	= "Autres achats et charges externes"	23(cr)
          intitule: "Autres achats et charges externes",
          rang: 1,
          ajouter: [{base: "crs",lignes: [23] },],
          soustraire: [],
        },
        {
          //Valeur Ajoutée= "Marge brute" - "Autres achats et charges externes"	 = 2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)-23(cr)
          intitule: "Valeur Ajoutée",
          rang: 2,
          ajouter: [{ base: "crs", lignes: [2,3,5,6]   }],
          soustraire: [{ base: "crs", lignes: [16,22,23]   }],
        },
        {
          // Subvention d'exploitation	= "Subvention d'exploitation" + "Reprise des fonds dédiés de N-1" + "Correction fonds dédiés sur Subventions" 
          //= 	4(cr)+8(cr)-7(cr)
          intitule: "Subvention d'exploitation",
          rang: 1,
          ajouter: [{ base: "crs", lignes: [4,8]},],
          soustraire: [{ base: "crs", lignes: [7]}],
        },
        {
          //Frais de personnel	= "Salaires et traitements bruts" + "Cotisations sociales patronales" = 	52(cr)+53(cr)
          intitule: "Frais de personnel",
          rang: 1,
          ajouter: [{base: "crs",lignes: [52,53],},],
          soustraire: [],
        },
        {
          //Impôts, taxes et versement assimilés	 = "Impôt, taxes et versements assimilés"	 = 51(cr)
          intitule: "Impôts, taxes et versement assimilés",
          rang: 1,
          ajouter: [{base: "crs",lignes: [51],},],
          soustraire: [],
        },
        {
          // Transfert de charges	 = "Transferts de charges" =	14(cr)
          intitule: "Transfert de charges",
          rang: 1,
          ajouter: [{ base: "crs", lignes: [14], }],
          soustraire: [],
        },
        {
          //Excédent brut d'exploitation= "Valeur Ajoutée" + "Subvention d'exploitation" + "Transfert de charges" 
          //- "Frais de personnel" - "Impôts, taxes et versement assimilés"
          // = 	2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)-23(cr)+4(cr)+8(cr)-7(cr)+14(cr)-52(cr)-53(cr)-51(cr)
          intitule: "Excédent brut d'exploitation",
          rang: 2,
          ajouter: [{ base: "crs", lignes: [2,3,5,6,4,8,14] },],
          soustraire: [{ base: "crs", lignes: [7,16,22,23,52,53,51] },],
        },
        {
          //Autres charges & produits de gestion courante	 = "Autres produits de gestion courante" - "Autres charges de gestion courante"	 = 9(cr)-54(cr)
          intitule: "Autres charges & produits de gestion courante",
          rang: 1,
          ajouter: [{base: "crs",lignes: [9] },],
          soustraire: [{base: "crs",lignes: [54] },],
        },
        {
          //DNAP exploitation	 = "Reprise sur amort. et provisions exploitation" - "Dotations aux amortissements et provisions d'exploitation"= 10(cr)-55(cr)
          intitule: "DNAP exploitation", // Dotations nettes aux amortissements et provisions (DNAP) exploitation", modif cf mail 12/042023
          rang: 1,
          ajouter: [{base: "crs",lignes: [10],},],
          soustraire: [{base: "crs",lignes: [55],}],
        },
        {
          //Résultat d'exploitation	 = "Excédent brut d'exploitation" + "Autres charges & produits de gestion courante"+ "DNAP exploitation"
          // = 	2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)-23(cr)+4(cr)+8(cr)-7(cr)+14(cr)-52(cr)-53(cr)-51(cr)+9(cr)-54(cr)+10(cr)-55(cr)
          intitule: "Résultat d'exploitation",
          rang: 2,
          ajouter: [{base: "crs",lignes: [2,3,5,6,4,8,14,9,10],},],
          soustraire: [{base: "crs",lignes: [7,16,22,23,52,53,51,54,55],},],
        },
        {
          // Résultat financier hors DNAP financiers	"Autres produits financiers" - "Intérêts d'emprunts" - "Autres charges financières"
          // = 	62(cr)-65(cr)-66(cr)
          intitule: "Résultat financier hors DNAP financiers", // "Résultat financier hors dotations nettes aux amortissements et provisions financiers", cf mail du 12/04
          rang: 1,
          ajouter: [{ base: "crs", lignes: [62]}],
          soustraire: [{ base: "crs", lignes: [65,66]}],
        },
        {
          //DNAP financiers	"Reprises sur amortissements et provisions financières" - "Dotations aux amortissements et provisions financières"
          // = 	63(cr)-67(cr)
          intitule: "DNAP financiers", // "Dotations nettes aux amortissements et provisions financiers", cf mail du  12/04
          rang: 1,
          ajouter: [{base: "crs",lignes: [63],},],
          soustraire: [{base: "crs",lignes: [67],}],
        },
        {
          //Résultat courant =	"Résultat d'exploitation" + "Résultat financier hors DNAP financiers" + "DNAP financiers"
          // = 	2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)-23(cr)+4(cr)+8(cr)-7(cr)+14(cr)-52(cr)-53(cr)-51(cr)+9(cr)-54(cr)+10(cr)-55(cr)+62(cr)-65(cr)-66(cr)+63(cr)-67(cr)
          intitule: "Résultat courant",
          rang: 2,
          ajouter: [{ base: "crs", lignes: [2,3,5,6,4,8,14,9,10,62,63] },],
          soustraire: [{base: "crs",lignes: [7,16,22,23,52,53,51,54,55,65,66,67],}],
        },
        {
          //Résultat exceptionnel hors DNAP exceptionnel	= "Q/P de subv. Invt virée au résultat" + "Produits de cession des éléments d'actif" 
          //+ "Autres produits exceptionnels" - "Valeurs comptables des éléments d'actif cédés" - "Autres charges exceptionnelles"	
          // = 70(cr)+72(cr)+73(cr)-76(cr)-77(cr)
          intitule: "Résultat exceptionnel hors DNAP exceptionnel", //Résultat exceptionnel hors dotations nettes aux amortissements et provisions exceptionnel", cf mail du 12/04
          rang: 1,
          ajouter: [{base: "crs",lignes: [70,72,73],}],
          soustraire: [{base: "crs",lignes: [76,77],}],
        },
        {
          //DNAP exceptionnel	 = "Reprise sur amortissements et provisions exceptionnelles" - "Dotations aux amortissements et provisions exceptionnelles"
          // = 	71(cr)-75(cr)
          intitule: "DNAP exceptionnel", //"Dotations nettes aux amortissements et provisions exceptionnel",cf mail du 12/04
          rang: 1,
          ajouter: [{base: "crs",lignes: [71],},],
          soustraire: [{base: "crs",lignes: [75],},],
        },
        {
          //Participation des salariés =	"Participation des salariés"	79(cr)
          intitule: "Participation des salariés",
          rang: 1,
          ajouter: [{ base: "crs", lignes: [79] }],
          soustraire: [],
        },
        {
          //Impôt sur les sociétés	= "Impôts sur les sociétés" - "Crédit d'impôts"	80(cr)-81(cr)
          intitule: "Impôt sur les sociétés",
          rang: 1,
          ajouter: [{ base: "crs", lignes: [80] }],
          soustraire: [{ base: "crs", lignes: [81] }],
        },
        {
          //Résultat Net	"Résultat courant" + "Résultat exceptionnel hors DNAP exceptionnel" + "DNAP exceptionnel" - "Impôt sur les sociétés"	
          // = 2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)-23(cr)+4(cr)+8(cr)+7(cr)+14(cr)-52(cr)-53(cr)-51(cr)+9(cr)-54(cr)+10(cr)-55(cr)+62(cr)
          // -65(cr)-66(cr)+63(cr)-67(cr)+70(cr)+72(cr)+73(cr)-76(cr)-77(cr)+71(cr)-75(cr)-79(cr)-80(cr)+81(cr)
          intitule: "Résultat Net",
          rang: 3,
          ajouter: [{ base: "crs", lignes: [2,3,5,6,4,8,14,9,10,62,63,70,72,73,71,81]},],
          soustraire: [{ base: "crs",lignes: [7,16,22,23,52,53,51,54,55,65,66,67,76,77,75,79,80]}],
        },
        {
          //Capacité d’autofinancement= 	"RESULTAT NET" + "Dotations aux amortissments et provisions d'exploitation" 
          //+ "Dotations aux amortissements et provisions financières" + "DNAP exceptionnel" + "Valeurs comptables des éléments d'actif cédés" 
          //- "Reprise sur amort. et provisions exploitation" - "Reprises sur amortissements et provisions financières"
          // - "Reprise sur amortissements et provisions exceptionnelles" - "Produits de cession des éléments d'actif" 
          //- "Q/P de subv. Invt virée au résultat"

          // Correctif sur cette partie de formule :  (cf remarque cdc)
          // 67(cr)+70(cr)+72(cr)+73(cr)-76(cr)-77(cr)+71(cr)-75(cr)-80(cr)+81(cr)+55(cr)+67(cr)-71(cr)+75(cr)+76(cr)-10(cr)-63(cr)- 72(cr)-70(cr)
          // = 67(cr)+73(cr)-77(cr)-80(cr)+81(cr)+55(cr)+67(cr)-10(cr)-63(cr)

          // normal d'avoir 67(cr) en double ?


          // nouvelle formule cf recette 11/07/2024

          //Capacité d’autofinancement= 	"RESULTAT NET" + "Dotations aux amortissments et provisions d'exploitation" 
          //+ "Dotations aux amortissements et provisions financières" + "DNAP exceptionnel" + "Valeurs comptables des éléments d'actif cédés" 
          //- "Reprise sur amort. et provisions exploitation" - "Reprises sur amortissements et provisions financières"
          // - "Reprise sur amortissements et provisions exceptionnelles" - "Produits de cession des éléments d'actif" 
          //- "Q/P de subv. Invt virée au résultat" + "Correction fonds dédiés sur Subventions"-"Reprise des fonds dédiés de N-1"

          // 2(cr)+3(cr)+5(cr)+6(cr)-16(cr)-22(cr)-23(cr)+4(cr)+8(cr)-7(cr)+14(cr)-52(cr)-53(cr)-51(cr)+9(cr)-54(cr)+10(cr)-55(cr)+62(cr)-65(cr)-66(cr)+63(cr)-67(cr)+70(cr)+72(cr)+73(cr)-76(cr)-77(cr)+71(cr)-75(cr)-80(cr)+81(cr)
          // -79(cr) +55(cr)+67(cr)-71(cr)+75(cr)+76(cr)-10(cr)-63(cr)- 72(cr)-70(cr) + 7(cr) - 8(cr)

          // = 2(cr)+3(cr)+4(cr)+5(cr)+6(cr)+9(cr)+14(cr)+62(cr)+73(cr)+81(cr)-16(cr)-22(cr)-23(cr)-51(cr)-52(cr)-53(cr)-54(cr)-65(cr)-66(cr)-77(cr)-79(cr)-80(cr)

          intitule: "Capacité d’autofinancement",
          rang: 3,
          ajouter: [{ base: "crs", lignes: [2,3,4,5,6,9,14,62,73,81] }],
          soustraire:  [{ base: "crs", lignes: [16,22,23,51,52,53,54,65,66,77,79,80] }], 
        },
      ],
    
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters["currentUser/isLoggedIn"];
    },

    previs_years_ordered(){
      return _.sortBy(this.diagnostic_years)
    }
  },

  watch: {
    kilo_euro(val) {
      EventBus.$emit("kilo_euroChanged", val);
    },
    //possibles_diagnostic_years
    diagnostic_years(val, old) {

      if (this.possibles_diagnostic_years.length > 0 && this.selectedClient) {

        this.cr_loading = true;
        this.sig_loading = true;
        this.GlobalLoading = true;

        this.get_crs().then(() => {
          this.cr_loading = false;          
            this.set_sigs().then(() => {
              this.sig_loading = false;
              this.GlobalLoading = false;
            });          

        });
      }
    },

    selectedClient(val) {
      this.GlobalLoading = true;

      this.diagnostic_years = [];

      if (val) {
        //chargement de la liste des années de previs pour le SIG (depend des annees de CR previ)
        this.getSIGprevisYears();
        localStorage.selectedClient = JSON.stringify(val);
        EventBus.$emit("ClientChanged", val);
      }
    },
  },

  methods: {
    refresh() {
      this.sigDatatableKey++;      
      this.exportSigDatatableKey++;      
    },

    // toggleAllRowVisibility pour afficher masquer toutes les lignes
    // dans l'exportation image d'un tableau

    toggleAllRowVisibility(state, targetData) {
      _.map(targetData, function (obj) {
        obj.show = state;
      });
      this.refresh();
    },

    // toggleRowVisibility pour afficher masquer une ligne
    // avec ses enfants selon les cas
    // target = jeux de donnée cible
    // row = identifiant de la ligne

    toggleRowVisibility(state, target, index) {
      let i = index;

      // si rang = 3
      // on ne s'occupe pas des enfants
      if (target[index].rang == 3) {
        target[index].show = state;
      } else if (target == this.ffs) {
        do {
          target[i].show = state;
          i--;
        } while (target[i] && target[i].rang < target[index].rang);
      } else {
        do {
          target[i].show = state;
          i++;
        } while (target[i] && target[i].rang < target[index].rang);
      }
      this.refresh();
    },

    exportImage(tab) {
      var node = document.getElementById(tab);
      htmlToImage
        .toPng(node)
        .then(function (dataUrl) {
          var link = document.createElement("a");
          link.download = "previsionnel-sig.png";
          link.href = dataUrl;
          link.click();
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    },

    set_excelHeaders() {
      var headers = { intitule: "intitule" };
      this.diagnostic_years.forEach((year) => {
        headers["année " + year] = year;
      });
      return headers;
    },

    /*
     * format value in K€
     */
    format(value, item) {
      // exception au formatage en Euro (precision au centième)
      if (
        item.intitule ==
        "Productivité du personnel rapportée au budget annuel (hors personnel extérieur) (N°3)"
      ) {
        return this.kilo_euro == true
          ? parseFloat(value / 1000).toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 4,
            })
          : parseFloat(value).toLocaleString("fr-FR", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            });
      }

      if (isNaN(parseFloat(value)) || item.taux || item.sans_unite) {
        if (isNaN(value)) {
          return value;
        } else {
          return parseFloat(value).toFixed(1);
        }
      }
      if (item.jour || item.annee) {
        return Math.round(value);
      }
      // formatage en K€ on préfère que les montants soient arrondis à l’unité cf recette du 31/03/2023 et mail du 12/04
      return this.kilo_euro == true
        ? parseFloat(value / 1000).toLocaleString("fr-FR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
        : parseFloat(value).toLocaleString("fr-FR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
    },

    pourcent_sig(sig, annee) {
      var pourcent;
      var base;
      if (this.pourcent_PE == true) {
        base = parseFloat(
          _.filter(this.crs, {"intitule":"PRODUITS D'EXPLOITATION","annee":annee})[0].montant
        );
      } else {
        base = parseFloat(
          _.filter(this.sigs, ["intitule", "Chiffre d'affaires"])[0][annee]
        );
      }

      if (parseFloat(base) != 0) {
        pourcent = parseFloat(
          (parseFloat(sig[annee]) * 100) / parseFloat(base)
        ).toFixed(1);

        if (pourcent > 200) {
          return ">200";
        }
        if (pourcent < -200) {
          return "<200";
        }
      } else {
        pourcent = 0.0; // Modifier les «-» provenant d’une division par 0 (N/A) et remplacer par 0 (cf recette 14/12/2023)
      }

      return parseFloat(pourcent).toFixed(1);
    },

    /*
     * SIG
     */

    set_sigs() {
      this.sig_loading = true;

      // on profite pour ordonner les années par ordre croissant
      let previs_years_ordered= _.sortBy(this.diagnostic_years)

      return new Promise((resolve, reject) => {
        var years_values;
        var value;

        _.forEach(this.sigs, (sig, key) => {
          years_values = {};
          
          _.forEach(previs_years_ordered, (annee) => {
            value = 0;
            if (sig.ajouter) {
              _.forEach(sig.ajouter, (ajout) => {               
                
                
                // somme des lignes du CR dont l'ordre est dans ajout.lignes pour l'annee considérée 
                // sera ajouter au total
                let ajouter = _.chain(this.crs)
                .filter(item => _.includes(ajout.lignes,item.order) && item.annee == annee)
                .sumBy (item => parseFloat(item.montant)) 
                .value()

                value = parseFloat(value) + parseFloat(ajouter);
              });
            }

            if (sig.soustraire) {
              _.forEach(sig.soustraire, (soustraction) => {


                // somme des lignes du CR dont l'ordre est dans ajout.lignes pour l'annee considérée 
                // sera soustrait du total
                
                let soustraire = _.chain(this.crs)
                .filter(item => _.includes(soustraction.lignes,item.order) && item.annee == annee)
                .sumBy (item => parseFloat(item.montant)) 
                .value()

                value = parseFloat(value) - parseFloat(soustraire);
              });
            }

            years_values[annee] = parseFloat(value).toFixed(2);
          });

          this.sigs[key] = Object.assign({}, this.sigs[key], years_values, {
            show: "1",
          });
        });

        resolve();
      });
    },

    /*
     * somme selon class
     */

    get_somme(classes, type, annee) {
      let payload = {
        client_id: this.selectedClient.id,
        annee: annee,
        classes: classes,
        type: type,
      };

      return new Promise((resolve, reject) => {
        axios
          .post("/api/diag/analyse/somme", payload)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    /*
     * Compte de resultat
     */

    get_crs() {
      this.cr_loading = true;

      let payload = {
        client_id: this.selectedClient.id,
        annees: this.diagnostic_years,
      };

      return new Promise((resolve, reject) => {
        axios
          .post("/api/previsionnel-sig-load-cr", payload)
          .then((response) => {
            this.crs = _.orderBy(response.data, ["order"], ["asc"]);
            this.cr_loading = false;
            resolve();
          })
          .catch((err) => {
            this.cr_loading = false;
            reject(err);
          });
      });
    },

    /*
     * ordre croissant des onglets années
     */

    orderYear() {
      this.diagnostic_years = _.sortBy(this.diagnostic_years);
    },

    /*
     * Liste des clients
     */

    getClients() {
      this.ClientsLoading = true;
      this.Loading = true;

      return new Promise((resolve, reject) => {
        axios
          .get("/api/userclientlist")
          .then((response) => {
            this.clients = response.data.data;
            this.ClientsLoading = false;
            this.Loading = false;
            resolve(response);
          })
          .catch((err) => {
            console.log("/api/userclientlist/ KO", err);
            console.log(err);
            this.ClientsLoading = false;
            this.Loading = false;
            reject(err);
          });
      });
    },

    getSIGprevisYears() {
      if (!this.selectedClient.id) {
        this.diagnostic_years = [];
        return;
      }
      this.diagnostic_years_loading = true;

      return new Promise((resolve, reject) => {
        axios
          .get(
            "/api/previsionnel-sig/years/" +
              this.selectedClient.id
          )
          .then((response) => {

            console.log(response.data)

            this.possibles_diagnostic_years = response.data;

            // les trois dernieres années sont selectionnées par default
            
            this.diagnostic_years = _.take(this.possibles_diagnostic_years, 3);

            this.diagnostic_years_loading = false;
            resolve(response);
          })
          .catch((err) => {
            this.possibles_diagnostic_years = [];
            this.diagnostic_years_loading = false;
            reject(err);
          });
      });
    },

  },

  mounted() {
    this.getClients().then(() => {
      // recuperation du client selectionné sauvegardé en local storage
      // mise a jour du local storage si entretemps un paramétrage client a été mis à jour

      if (localStorage.selectedClient) {
        var selectedClientInlocalstorage = JSON.parse(
          localStorage.selectedClient
        );
        this.selectedClient = _.find(this.clients, {
          id: selectedClientInlocalstorage.id,
        });
        localStorage.selectedClient = JSON.stringify(this.selectedClient);
      }
    });
  },
};
</script>